var exports = {
  "button": "x61f99309--342a0e--button",
  "button--primary": "x61f99309--342a0e--button--primary",
  "button--secondary": "x61f99309--342a0e--button--secondary",
  "button--neutral": "x61f99309--342a0e--button--neutral",
};

module.exports = exports;
